export default "__VITE_ASSET__7a7c86c7__"